<template>
  <el-alert v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-alert>
</template>
<script>
export default {
  name: "aia-alert"
};
</script>